import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HARHistoricEnglandRegionFilter({
  setFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="region"
      filters={filters}
      id="historic-england-region"
      label="Historic England region"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HARHistoricEnglandRegionFilter);
